<template>
  <div id="app">
  	<router-view></router-view>
  </div>
</template>


<script>
export default {
  // components:{
  // 	vHeader,
  // 	vFooter
  // },
  created(){
     this.setLang(localStorage.getItem('currentLangIndex') || '1' );
  }
}
</script>

<style lang="less">
// 引入字体文件
@import url('../static/css/font.css');
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  
}

</style>



// WEBPACK FOOTER //
// src/App.vue